declare const window: any;

import {
    Error,
} from 'one-core';

export const settings = (
    url: string,
    options: any = {},
) => (
        new Promise((resolve, reject) => {
            const { params = {
                cache: 'no-cache',
                headers: {
                    "Content-Type": "application/json",
                },
            } } = options;

            // TODO: replace with abstracted server api
            fetch(url, params).then((resp: any) => {
                const json = resp.json();
                resolve(json);
            }).catch((exp) => {
                const error: Error = {
                    code: 'ONE-CORE:SETTINGS-NOT-ACCESSIBLE',
                    description: `Unable to access ${url}`,
                    context: {
                        url,
                        params,
                        options,
                    },
                };
                reject(error);
            })
        })
    );